var map = {
	"./ContainerMountPaths.vue": 3198,
	"./Mount.vue": 34637,
	"./awsElasticBlockStore.vue": 35531,
	"./azureDisk.vue": 6539,
	"./azureFile.vue": 15595,
	"./emptyDir.vue": 64025,
	"./gcePersistentDisk.vue": 77971,
	"./hostPath.vue": 55659,
	"./index.vue": 74868,
	"./nfs.vue": 76825,
	"./secret.vue": 18528,
	"./vsphereVolume.vue": 80926,
	"edit/workload/storage/ContainerMountPaths.vue": 3198,
	"edit/workload/storage/Mount.vue": 34637,
	"edit/workload/storage/awsElasticBlockStore.vue": 35531,
	"edit/workload/storage/azureDisk.vue": 6539,
	"edit/workload/storage/azureFile.vue": 15595,
	"edit/workload/storage/emptyDir.vue": 64025,
	"edit/workload/storage/gcePersistentDisk.vue": 77971,
	"edit/workload/storage/hostPath.vue": 55659,
	"edit/workload/storage/index.vue": 74868,
	"edit/workload/storage/nfs.vue": 76825,
	"edit/workload/storage/secret.vue": 18528,
	"edit/workload/storage/vsphereVolume.vue": 80926
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68219;